'use strict';

var typography = {};

exports.__exports = typography;
//# sourceMappingURL=typography3.cjs.map
